import { EN } from './EN';

/**
 * English is the reference Type.
 * Every properties declared in EN must be present in other lang, even if empty
 *
 * To use dynamic values in translations, use the 'replaceInTranslation' pipe
 */
type I18n = typeof EN;

function getLang(lg: string | null): I18n {
  switch (lg) {
    // case 'fr':
    //   return FR;
    case 'en':
    case 'uk':
    case 'us':
      return EN;

    default:
      return EN;
  }
}

export const I18ns: I18n = getLang(localStorage.getItem('lang'));

/**
 * Returns a translation from a key as an object property
 *
 * ex: getTranslation(Trads.shared, 'Yes');
 *
 * @param obj Object containing translations
 * @param key Property of the object
 * @returns String containing the translation
 */
export function getTranslation(obj: any, key: string): string {
  if (obj && key && Object.keys(obj).some((k) => k === key)) {
    return obj[key];
  }
  return '';
}
